export var HttpMethod;
(function (HttpMethod) {
    HttpMethod["Get"] = "get";
    HttpMethod["Post"] = "post";
    HttpMethod["Put"] = "put";
    HttpMethod["Patch"] = "patch";
    HttpMethod["Delete"] = "delete";
    HttpMethod["Head"] = "head";
})(HttpMethod || (HttpMethod = {}));
export var HttpResponseType;
(function (HttpResponseType) {
    HttpResponseType["Raw"] = "raw";
    HttpResponseType["Json"] = "json";
    HttpResponseType["Text"] = "text";
})(HttpResponseType || (HttpResponseType = {}));
//# sourceMappingURL=http.js.map